import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }

import { ref, computed } from 'vue';
import { useMutation } from '@vue/apollo-composable';
import { ComputeTaskUpdateDocument, ComputeTaskType } from '@/gql/graphql';
import { BAlert, BButton, BModal, BSpinner } from 'bootstrap-vue-next';
import { COMPUTE_TASK_STATUS } from '@/constants';

// --- Component properties ---

export default /*@__PURE__*/_defineComponent({
  __name: 'ComputeTaskAbort',
  props: {
    show: { type: Boolean },
    task: {}
  },
  emits: ['close', 'closeAndRefresh'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// --- Component emits ---
const emits = __emit;

// --- Component state ---
const show = computed<boolean>(() => {
  return props.show;
});

// --- Mutation: Rename Data Object ---
const mutationInProgress = ref<boolean>(false);
const mutationError = ref<string | null>(null);
const mutationShowSuccess = ref<boolean>(false);

const {
  mutate: executeMutation,
  onDone: onMutationDone,
  onError: onMutationError,
} = useMutation(ComputeTaskUpdateDocument);

onMutationDone((res) => {
  mutationInProgress.value = false;
  if (res.data && res.data.computeTaskUpdate) {
    console.debug(
      'ComputeTask abortion request successful:',
      res.data.computeTaskUpdate
    );
    mutationShowSuccess.value = true;
    setTimeout(() => {
      mutationShowSuccess.value = false;
      emits('closeAndRefresh');
    }, 1000);
  } else {
    mutationError.value = 'Task abortion request failed: ' + res.data;
    console.error('Task abortion request failed:', res.data);
  }
});
onMutationError((err) => {
  console.error('Error aborting compute task:', err);
  mutationInProgress.value = false;
  mutationError.value = err.message;
});

// --- Handle component actions ---
function onAbortConfirmed() {
  if (!props.task.id) {
    mutationError.value = 'Task ID for abortion not provided';
    console.error('Task ID for abortion not provided');
    return;
  }

  mutationInProgress.value = true;
  mutationError.value = null;
  executeMutation({
    id: props.task.id,
    status: COMPUTE_TASK_STATUS.ABORTING,
    abortedAt: new Date(),
  });
}

function handleCloseModal() {
  emits('close');
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(BModal), {
      modelValue: show.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((show).value = $event)),
      onHide: handleCloseModal
    }, {
      title: _withCtx(() => [
        _createVNode(_component_font_awesome_icon, {
          icon: "times",
          class: "me-2"
        }),
        _cache[3] || (_cache[3] = _createTextVNode(" Abort ", -1)),
        _createElementVNode("strong", null, _toDisplayString(props.task.name), 1)
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(BButton), {
          variant: "secondary",
          onClick: handleCloseModal
        }, {
          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
            _createTextVNode(" Cancel ", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_unref(BButton), {
          variant: "danger",
          disabled: mutationInProgress.value || mutationShowSuccess.value,
          onClick: onAbortConfirmed
        }, {
          default: _withCtx(() => [
            (mutationInProgress.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                  _cache[7] || (_cache[7] = _createTextVNode(" Requesting Abortion ", -1)),
                  _createVNode(_unref(BSpinner), {
                    small: "",
                    label: ""
                  })
                ]))
              : (mutationShowSuccess.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                    _cache[8] || (_cache[8] = _createTextVNode(" Abortion Requested ", -1)),
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['fa', 'check-double'],
                      class: "me-2"
                    })
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_3, " Abort Task "))
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("p", null, [
            _cache[4] || (_cache[4] = _createTextVNode(" Are you sure you want to abort the task ", -1)),
            _createElementVNode("strong", null, _toDisplayString(props.task.name), 1),
            _cache[5] || (_cache[5] = _createTextVNode("? ", -1))
          ]),
          _createVNode(_unref(BAlert), {
            modelValue: mutationError.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((mutationError).value = $event)),
            variant: "danger",
            dismissible: "",
            class: "mt-3",
            onDismissed: _cache[1] || (_cache[1] = ($event: any) => (mutationError.value = null))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(mutationError.value), 1)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})